import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthCallback } from "./components/AuthCallback";
import { Toaster } from "./components/ui/sonner";

// Pages
import { HomePage } from "./pages/HomePage";
import { ArticlePage } from "./pages/ArticlePage";
import { WritePage } from "./pages/WritePage";
import { ProfilePage } from "./pages/ProfilePage";
import { TopicPage } from "./pages/TopicPage";
import { SearchPage } from "./pages/SearchPage";
import { BookmarksPage } from "./pages/BookmarksPage";
import { DraftsPage } from "./pages/DraftsPage";
import { AdminPage } from "./pages/AdminPage";
import { ReadingHistoryPage } from "./pages/ReadingHistoryPage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import SeriesPage from "./pages/SeriesPage";

// Router wrapper to handle auth callback
const AppRouter = () => {
  const location = useLocation();
  
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  // CRITICAL: Check URL fragment for session_id SYNCHRONOUSLY during render
  // This prevents race conditions by processing OAuth callback FIRST
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/article/:articleId" element={<ArticlePage />} />
      <Route path="/write" element={<WritePage />} />
      <Route path="/write/:articleId" element={<WritePage />} />
      <Route path="/profile/:userId" element={<ProfilePage />} />
      <Route path="/topic/:topicName" element={<TopicPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/bookmarks" element={<BookmarksPage />} />
      <Route path="/drafts" element={<DraftsPage />} />
      <Route path="/history" element={<ReadingHistoryPage />} />
      <Route path="/analytics" element={<AnalyticsPage />} />
      <Route path="/series/:seriesId" element={<SeriesPage />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster position="bottom-right" richColors />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
